<template>
    <div class="modal fade detail-boat" :id="idModalBoatData" tabindex="-1" role="dialog" aria-labelledby="myLargeModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">EMBARCACION {{ nameShip }} </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                                        
                    <div class="card col-10 offset-1 col-md-6 offset-md-3" align="center" style="width: 500px;">
                        <img :src="boatImage.path" alt="" class="card-img-top">
                    </div>
                    <div class="form-row">
                        <div class="form-group col-12 col-md-4">
                            <label for="nombre_embarcacion" class="badge badge-primary">Nombre de la Embarcacion</label>                    
                            <input type="text" readonly class="form-control-plaintext" v-model="boat.name" id="enrollment_boat">
                        </div>
                        
                        <div class="form-group col-12 col-md-4">
                            <label for="bandera_embarcacion" class="badge badge-primary">Bandera</label>
                            <input type="text" readonly class="form-control-plaintext" value="Bolivia">
                        </div>

                        <div class="form-group col-12 col-md-4">
                            <label for="vencimiento_embarcacion" class="badge badge-primary">Vencimiento</label>
                            <input type="text" readonly class="form-control-plaintext" v-model="boat.expiration">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-4">
                            <label for="material_head" class="badge badge-primary">Material del casco</label>
                            <input type="text" readonly class="form-control-plaintext" v-model="boat.material_construction" >
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="type_ship" class="badge badge-primary">Tipo de nave</label>
                            <input type="text" readonly class="form-control-plaintext" v-model="boat.type_ship" >
                        </div>

                        <div class="form-group col-12 col-md-4">
                            <label for="type_navigate" class="badge badge-primary">Tipo Navegacion</label>
                            <input type="text" readonly class="form-control-plaintext" v-model="boat.destiny_navigate" >
                        </div>
                    </div>

                    <div class="form-row">
                        
                        <div class="form-group col-12 col-md-4">
                            <label for="type_ship" class="badge badge-primary">Tipo de Propulsion</label>
                            <input type="text" readonly class="form-control-plaintext" v-model="boat.propulsion" >
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="year_construction" class="badge badge-primary">Año de construccion</label>
                            <input type="text" readonly class="form-control-plaintext" v-model="boat.year_construction" >
                        </div>

                        <div class="form-group col-12 col-md-4">
                            <label for="type_ship" class="badge badge-primary">Destino Actividad</label>
                            <input type="text" readonly class="form-control-plaintext" v-model="boat.activity">
                        </div>                                      
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-2">
                            <label for="trb" class="badge badge-primary">TRB</label>
                            <input type="text" readonly class="form-control-plaintext" v-model="boat.trb">
                        </div>
                        <div class="form-group col-12 col-md-2">
                            <label for="trn" class="badge badge-primary">TRN</label>
                            <input type="text" name="trn" readonly class="form-control-plaintext" v-model="boat.trn">
                        </div>
                        <div class="form-group col-12 col-md-2">
                            <label for="eslora" class="badge badge-primary">Eslora</label>
                            <input type="text" readonly class="form-control-plaintext" v-model="boat.eslora" name="eslora">
                        </div>
                        <div class="form-group col-12 col-md-2">
                            <label for="manga" class="badge badge-primary">Manga</label>
                            <input type="text" readonly class="form-control-plaintext" v-model="boat.manga" >
                        </div>
                        <div class="form-group col-12 col-md-2">
                            <label for="puntal" class="badge badge-primary">Puntal</label>
                            <input type="text" readonly class="form-control-plaintext" v-model="boat.puntal">
                        </div>
                        <div class="form-group col-12 col-md-2">
                            <label for="eslora" class="badge badge-primary">Calado</label>
                            <input type="text" readonly class="form-control-plaintext" v-model="boat.calado" name="calado" placeholder="Calado" autocomplete="off">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="trb" class="badge badge-primary">Nombre Propietario</label>
                            <input type="text" readonly class="form-control-plaintext" v-model="owner.name">
                        </div>
                        <div class="form-group col-12 col-md-6">
                            <label for="trb" class="badge badge-primary">CI/NIT</label>
                            <input type="text" readonly class="form-control-plaintext" v-model="owner.number_identification">
                        </div>
                    </div>

                </div> 
                    
                <div class="modal-footer">
                    
                    <button type="button" class="btn btn-outline-danger" data-dismiss="modal"><font-awesome-icon icon="times-circle" size="lg" /></button>                        
                </div>
            </div>
        </div>            
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
const qs = require('qs');

export default {
    name:'modal-boat',
    props:{
        nameShip:String,
        idModalBoatData:String,
        boat:Object,
        boatImage:Object,
        owner:Object
    },
    data(){
        return {
            btnSend:false
        }
    },
    methods:{
        
    },
    computed:{
        // urlP(){
        //     return `${this.$urlP.getUrl()}img/ships/${this.boatImage.path}`;
        // }
    }
}
</script>

<style>
.detail-boat{
    overflow-y: scroll !important;
}
</style>



// WEBPACK FOOTER //
// src/components/verify/ModalBoatData.vue